// @ts-expect-error pure js
import useResource from "./use-resource.js";
import type { MailTemplate } from "../models/mailTemplate";

interface UseMailTemplate {
  mailTemplate: MailTemplate | null;
  error: unknown;
  isLoading: boolean;
  createOrUpdateMailTemplate: (
    values: Partial<MailTemplate>,
  ) => Promise<MailTemplate>;
  resetMailTemplate: (fieldsToReset: string[]) => Promise<MailTemplate>;
}

export default function useMailTemplate(
  staticId: string,
  profileBailleurId?: number,
): UseMailTemplate {
  const url = profileBailleurId
    ? `/profiles/${profileBailleurId}/mail-templates/${staticId}`
    : `/account/mail-templates/${staticId}`;
  const {
    resource: mailTemplate,
    error,
    isLoading,
    update,
    mutate,
    axios,
  } = useResource(url);

  async function resetMailTemplate(
    fieldsToReset: string[],
  ): Promise<MailTemplate> {
    let newResource: MailTemplate | undefined;
    await mutate(
      async () => {
        const response = await axios.put(`${url}/reset`, fieldsToReset);
        newResource = response.data;
        return newResource;
      },
      { revalidate: false },
    );
    return newResource as MailTemplate;
  }

  return {
    mailTemplate,
    error,
    isLoading,
    createOrUpdateMailTemplate: update,
    resetMailTemplate,
  };
}
